<template>
<div>
	<!-- <ViewDetail ref="ViewDetail" @closePage="closePage" @refresh="refresh" @update="getList()"></ViewDetail> -->
	<!-- <ViewDetail ref="ViewDetail" :bg="true" :type="1"></ViewDetail> -->
	<div class="navBtn pl1x bdSub-bottom">
		<div class="tabBar cb active-c-main_E tra-fast_E mt0x">
			<button v-for="(item,index) in btnGroup_equipment" :key="index" class="cSub"  :class="{active:index==deviceIndex}" @click="changeTab(index)">{{item.title}}</button>
		</div>
	</div>
	<div class="tableScope bgContent">
		<InverterList ref="InverterList" v-if="btnGroup_equipment[deviceIndex].childRef=='InverterList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></InverterList>
		<AmmeterList ref="AmmeterList" v-if="btnGroup_equipment[deviceIndex].childRef=='AmmeterList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></AmmeterList>
		<ComponetList ref="ComponetList" v-if="btnGroup_equipment[deviceIndex].childRef=='ComponetList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></ComponetList>
		<WeatherList ref="WeatherList" v-if="btnGroup_equipment[deviceIndex].childRef=='WeatherList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></WeatherList>
		<CollectorList ref="CollectorList" v-if="btnGroup_equipment[deviceIndex].childRef=='CollectorList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></CollectorList>
		<MicroInverterList ref="MicroInverterList" v-if="btnGroup_equipment[deviceIndex].childRef=='MicroInverterList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></MicroInverterList>
		<CombinerBoxList ref="CombinerBoxList" v-if="btnGroup_equipment[deviceIndex].childRef=='CombinerBoxList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></CombinerBoxList>
		<RepeaterList ref="RepeaterList" v-if="btnGroup_equipment[deviceIndex].childRef=='RepeaterList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></RepeaterList>
		<BatteryList ref="BatteryList" v-if="btnGroup_equipment[deviceIndex].childRef=='BatteryList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></BatteryList>
		<DTUList ref="DTUList" v-if="btnGroup_equipment[deviceIndex].childRef=='DTUList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></DTUList>
		<APIList ref="APIList" v-if="btnGroup_equipment[deviceIndex].childRef=='APIList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></APIList>
		<FANList ref="FANList" v-if="btnGroup_equipment[deviceIndex].childRef=='FANList'" @refreshTree="$emit('refreshTree')" @viewDetail="viewDetail"></FANList>
	</div>
</div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import {getLanguageStr} from '@/util/language.js'
import * as lib from '@/util/lib.js';
// import ViewDetail from '@/view/device/device/ViewDetail.vue'
import InverterList from '@/view/maintain/part/childSys/InverterList'// 逆变器
import AmmeterList from '@/view/maintain/part/childSys/AmmeterList' // 电表列表
import ComponetList from '@/view/maintain/part/childSys/ComponetList' // 组件列表
import WeatherList from '@/view/maintain/part/childSys/WeatherList' // 气象列表
import CollectorList from '@/view/maintain/part/childSys/CollectorList' // 采集器列表
import MicroInverterList from '@/view/maintain/part/childSys/MicroInverterList' // 微逆列表
import CombinerBoxList from '@/view/maintain/part/childSys/CombinerBoxList' // 汇流箱列表
import RepeaterList from '@/view/maintain/part/childSys/RepeaterList' // 中继器列表
import BatteryList from '@/view/maintain/part/childSys/BatteryList' // 电池列表
import DTUList from '@/view/maintain/part/childSys/DtuList' //dtu列表
import APIList from '@/view/maintain/part/childSys/APIList' //API列表
import FANList from '@/view/maintain/part/childSys/FANList' //FAN列表
import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue';
import * as historyApi from '@/api/maintain/plant/list'

export default {
	name: 'childSysTable',
	components: {InverterList, AmmeterList, ComponetList, WeatherList,CollectorList,MicroInverterList,CombinerBoxList,RepeaterList,BatteryList,DTUList,APIList,FANList,DeviceDetail},
	computed: {
		...mapGetters({
			isOpen: 'stationDetail/isOpen'
		})
	},
	watch: {
		isOpen (val) {
			if (!val) {
				this.deviceIndex = 0
			}
		}
	},
	data () {
		return {
			btnGroup_equipment: [
				{title: getLanguageStr('word35', '逆变器'), api: 'OperationInverter', childRef: 'InverterList'},
				{title: getLanguageStr('word39', '电表'), api: 'OperationAmmeter', childRef: 'AmmeterList'},
				{title: getLanguageStr('word647', '组件'), api: 'OperationComponet', childRef: 'ComponetList'},
				{title: getLanguageStr('word38', '气象站'), api: 'OperationWeather', childRef: 'WeatherList'},
				{title: getLanguageStr('word34', '采集器'), api: 'OperationCollector', childRef: 'CollectorList'},
				{title: getLanguageStr('word804', '微逆'), api: 'OperationMicroInverter', childRef: 'MicroInverterList'},
				{title: getLanguageStr('word36', '汇流箱'), api: 'OperationCombinerBox', childRef: 'CombinerBoxList'},
				{title: getLanguageStr('word803', '中继器'), api: 'OperationRepeater', childRef: 'RepeaterList'},
				{title: getLanguageStr('word37', '电池'), api: 'OperationBattery', childRef: 'BatteryList'},
				{title: getLanguageStr('DTU', 'DTU'), api: 'OperationDTU', childRef: 'DTUList'},
				{title: getLanguageStr('API', 'API'), api: 'OperationAPI', childRef: 'APIList'},
				{title: getLanguageStr('FAN', 'FAN'), api: 'OperationFAN', childRef: 'FANList'}
			],
			stationId: null,
			systemId: null,
			deviceIndex: 0,
			level: 0,
			active: {}
		}
	},
	methods: {
		getLanguageStr,
		changeTab (index) {
			this.deviceIndex = index
			this.$nextTick(() => {
				this.$refs[this.btnGroup_equipment[this.deviceIndex].childRef].show({stationId: this.stationId, systemId: this.systemId, level: this.level, status: this.active})
			})
		},
		show (data) {
			
			this.active = data.status
			this.stationId = data.stationId
			this.systemId = data.systemId
			this.level = data.level
			this.changeTab(this.deviceIndex)
		},
		viewDetail (deviceId) {
			if (lib.doPermissions('B/A/A5')) {
					this.$nextTick(() => {
						this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],DeviceDetail,{bg:true},{
							'closePage': [],
							'refresh': [],
							'update': [],
							'showStations': [],
							'DeviceControls': [],
							'DeviceUpgrades': [],
							'Dels': []
						},{}).then(({ instance, childInstance }) => {
							childInstance.show({siteId: this.stationId, deviceId: deviceId}, '', instance);
						});
				//  this.$refs.ViewDetail.show({siteId: this.stationId, deviceId: device.id}, '', '', '', '', device.name) 
				})
			 // this.$refs.ViewDetail.show({siteId: this.stationId, deviceId: deviceId})
			} else {
				this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
			} 
		}
	}
}
</script>
<style lang="scss" scoped>
.mt0x{margin-top: 0!important}
.tabBar > *:not(.tabBar-ex){
		bottom: 0
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/part/childSys/ChildSysTable.vue